// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__RuInL","inputWrap":"CustomTip_inputWrap__2Jvbd"};